<div class="creative-card-grid">
  @for (card of cards; track card) {
    <app-creative-card [card]="card"></app-creative-card>
  }
</div>
